import { render, staticRenderFns } from "./OtherLinkFooter.vue?vue&type=template&id=29b995a4&"
import script from "./OtherLinkFooter.vue?vue&type=script&lang=js&"
export * from "./OtherLinkFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports